import {Component, OnInit, ViewEncapsulation, Input, OnDestroy} from '@angular/core';
import { takeWhile } from 'rxjs/operators';

import {Product} from '../../../models/product.model';
import { OrderService } from '../../../services/order.service';
import { Order } from '../../../models/order.model';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {ECOMMERCE_TYPE, PREORDER_TYPE} from '../../../constants/order-types';
import {isEmptyArray} from '../../../shared/utils';

@Component({
    selector: 'products-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProductsGridComponent implements OnInit, OnDestroy {

    _products: Product[];

    private alive = true;
    private orderType: string; // defined by  product type

    @BlockUI() blockUI: NgBlockUI;

    @Input() orderLookup = true;
    @Input() baseURI: string;
    @Input() activeOrder: Order;
    @Input() set products(val: Product[]) {
        this._products = val;
        if (!isEmptyArray(this._products)) {
            this.orderType = this._products[0].isBuyingWindow ? PREORDER_TYPE : ECOMMERCE_TYPE;
        } else {
            this.orderType = null;
        }

        this.getActiveOrder();
    }

    constructor(private orderService: OrderService) {}

    ngOnInit() {

        // wait until order server is initialized
        if (this.orderLookup) {
            this.orderService.isInitialized().pipe(takeWhile(() => this.alive)).subscribe(data => {
                if (data) {
                    this.getActiveOrder();
                }
            });
        }
    }



    getActiveOrder() {
        if (!this.orderLookup) {
            return;
        }

        if (!this.orderType) {
            return;
        }

        setTimeout(() => {
            this.activeOrder = this.orderType === PREORDER_TYPE ? this.orderService.activeBWOrder : this.orderService.activeODOrder;
        });
    }

    ngOnDestroy(): void {
        this.alive = false;
    }
}
